module.exports = __webpack_public_path__ + "media/images/front/timeline/about_us_12-126296bdf79e4690f1beebe4c728f828.webp";